import React from 'react';

const IconAlertTriangle = ({ className }) => (
  <svg
    className={className}
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.1593 14.9999L18.7722 24.0367H21.2242L21.8372 14.9999H18.1593Z"
      fill="currentColor"
    />
    <path
      d="M18.6338 28.466C18.9898 28.822 19.4446 28.9999 19.9982 28.9999C20.5651 28.9999 21.0199 28.822 21.3626 28.466C21.7186 28.1101 21.8965 27.6883 21.8965 27.2005C21.8965 26.6996 21.7186 26.2843 21.3626 25.9547C21.0199 25.612 20.5651 25.4406 19.9982 25.4406C19.4446 25.4406 18.9898 25.612 18.6338 25.9547C18.2779 26.2843 18.0999 26.6996 18.0999 27.2005C18.0999 27.6883 18.2779 28.1101 18.6338 28.466Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.8138 32.9999L19.9999 6.26221L1.18604 32.9999H38.8138ZM5.03883 30.9999L19.9999 9.73768L34.961 30.9999H5.03883Z"
      fill="currentColor"
    />
  </svg>
);

export default IconAlertTriangle;
